import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Button } from "@masterteam/mt-design-react";

import List from "../List";
import PercentageBadge from "../PercentageBadge";
import api from "../../../providers/api";
import { LEVELS } from "../../../configs/enums";
import { ReactComponent as ArrowDown } from "../../../assets/images/arrow-down-curve.svg";
import { addToast } from "../../../helpers";
import { useToggle } from "../../../Hooks";

import "./style.scss";

function ListCollapse({
  selectable,
  item = {},
  selectedItem,
  onItemSelect,
  getIsSelected,
  getTitle,
  getHeaderTitle,
  childrenKey = "Objectives",
  onUpdate,
  apiKey,
  title,
  handleEqualOnClick = () => {},
}) {
  const intl = useIntl();
  const [toggle, onToggle] = useToggle();
  const [loading, setLoading] = useState();

  function renderHeaderTitle() {
    if (getHeaderTitle) return getHeaderTitle(item);
  }

  const total = item[childrenKey]?.reduce((acc, curr) => acc + curr?.Weight, 0);
  const invalidTotal = total !== 100;

  const saveData = async () => {
    setLoading(true);
    try {
      const res = await api.weight.update({
        Level: LEVELS[apiKey],
        Weights: item[childrenKey].map((item) => ({
          ID: item.ID,
          Weight: item.Weight,
        })),
      });
      const { StatusMessage, StatusCode } = res;
      if (StatusCode === "Success") {
        addToast.success("toast.successSave");
      } else {
        addToast.error(StatusMessage, {
          toastId: "get-users-error",
        });
      }
    } catch (error) {
      addToast.error(error, {
        toastId: "get-users-error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="weight-kpis__list-collapse">
      <div className="weight-kpis__list-collapse__actions-container">
        <div className="weight-kpis__list-collapse__actions-container__title">
          {title}
        </div>
        <div className="weight-kpis__list-collapse__actions">
          {onItemSelect && (
            <Button
              variant="dark"
              disabled={loading}
              className="weight-kpis__list-collapse__actions__action-btn"
              onClick={() => onItemSelect(null)}
            >
              {intl.formatMessage({ id: "common.reset" })}
            </Button>
          )}
          <Button
            variant="dark"
            onClick={() => handleEqualOnClick(item.ID)}
            disabled={loading}
            className="weight-kpis__list-collapse__actions__action-btn"
          >
            {intl.formatMessage({ id: "weight.equal" })}
          </Button>
          <Button
            variant="dark"
            disabled={invalidTotal}
            loading={loading}
            onClick={saveData}
            className="weight-kpis__list-collapse__actions__action-btn"
          >
            {intl.formatMessage({ id: "common.save" })}
          </Button>
          <PercentageBadge num={total} error={invalidTotal} />
        </div>
      </div>
      <div className="weight-kpis__list-collapse__header" onClick={onToggle}>
        <div className="weight-kpis__list-collapse__header__title">
          {renderHeaderTitle()}
        </div>
        <div className="weight-kpis__list-collapse__header__actions">
          <ArrowDown />
        </div>
      </div>
      <div className="weight-kpis__list-collapse__list-container">
        {toggle ? (
          <List
            selectable={selectable}
            data={item[childrenKey]}
            parentID={item.ID}
            getTitle={getTitle}
            selectedItem={selectedItem}
            onItemSelect={onItemSelect}
            getIsSelected={getIsSelected}
            disabled={loading}
            onUpdate={onUpdate}
          />
        ) : null}
      </div>
    </div>
  );
}

export default ListCollapse;
